import {Component, OnInit, Input, Output, EventEmitter} from '@angular/core';
import {CommonService} from '../../../services/common.service';
import {BsModalService} from 'ngx-bootstrap/modal';
import moment from 'moment';
import {environment} from '../../../../../environments/environment';

declare var jquery: any;
declare var $: any;

@Component({
    selector: 'app-user-eco-portail',
    templateUrl: './user-eco-portail.component.html',
    styleUrls: ['./user-eco-portail.component.css'],
    standalone: false
})
export class UserEcoPortailComponent implements OnInit {
  @Input() chantier;
  @Input() detail;
  @Input() edit: Boolean;
  @Input() add: Boolean;
  @Output() show = new EventEmitter<any>();

  factauto = {};
  avoirAuto = {};
  selected = [];
  dataArticle = [];
  listChantier = [{id: 0, libelleObjetEntite: 'Tous'}];
  listeAgence = [{id: 0, libelleObjetEntite: 'Tous'}];
  listeSite = [];
  isEmpty: Boolean = true;
  condition1: Boolean = false;
  condition2: Boolean = false;
  condition3: Boolean = false;
  isDepuisFicheDetenteur: Boolean = false;
  default = 0;
  nbdigit;
  classPresta: String = 'detailfact ';
  adresseAchat: Boolean = false;
  devise;
  pays = '';
  nbPage = 0;
  rowCount = 0;
  page = 0;
  focusIndex = 0;
  listUserEcoportail = [];
  listSite = [];
  showPassword: boolean = false;
  orderBy = '';
  isAsc = false;
  search = '';

  constructor(public common: CommonService) {
    this.nbdigit = this.common.local.getObject('paramSociete').nbDigitDevise;
    this.devise = this.common.local.getObject('paramSociete').devise;
    this.adresseAchat = this.common.local.getObject('paramSociete').adresseAchat;
  }

  ngOnInit() {
    this.isDepuisFicheDetenteur = this.chantier != null;
    this.detail = this.detail || {};
    console.log('this.chantier : ' + JSON.stringify(this.chantier));
    this.getListeAgence();
    this.getListUser().then(() => {
      this.isEmpty = false;
    });
    this.searchSite();
  }

  hide() {
    this.show.emit();
  }

  searchSite(event?) {
    const listeSite = this.common.getType('tousSite') || [];
    this.listSite = [...[{id: 0, libelleObjetEntite: 'Tous'}], ...listeSite];

    console.log( this.listSite)
  }

  selectRow(row) {
    this.focusIndex = this.listUserEcoportail.indexOf(row);
    this.selected = [row];
  }

  deleteLigne(row) {
    const temp = this.listUserEcoportail.filter(elt => elt !== row);
    this.listUserEcoportail = temp;
  }

  addLigne() {
    this.listUserEcoportail.push({
      index: this.listUserEcoportail.length, /* id: '1', */
      isDemande: true,
      isDesactive: false,
      isDocSsChantierAgence: true,
      isDocumentsUser: true,
      isLibraDataUser: true,
      isPriseCommandeUser: true,
      chantier: this.listChantier[0],
      agence: this.listeAgence[0],
      isEdit: true,
    });
    this.listUserEcoportail = [...this.listUserEcoportail];
    const length = this.listUserEcoportail.length - 1;
    setTimeout(function () {
      $('.login' + (length)).focus();
    }, 600);
  }

  getListUser() {
    const param = {
      'servlet': 'DBGestionUserEcoGED',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': this.isDepuisFicheDetenteur ? 3 : 1
        },
        'NUM_PAGE': {
          'typeParam': 'int',
          'valeur': this.page || 0
        },
        'CRITERE_RECHERCHE_LOGIN': {
          'typeParam': 'string',
          'valeur': this.search || ''
        },
        'COLUMN_TRIE': this.orderBy,
        'ORDRE_TRIE': this.isAsc ? 'ASC' : 'DESC',
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || 0
        }
      }
    };

    if (this.isDepuisFicheDetenteur) {
      param['data']['CLEF_CHANTIER'] = {
        'typeParam': 'int',
        'valeur': this.chantier['id'] || 0
      };
    }
    this.listUserEcoportail = [];
    return this.common.post('', { param: param }, true).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        if (datas.data && datas.data.length == 2) {
          this.listUserEcoportail = datas.data[0] || [];
          this.nbPage = datas.data[1].nbPages;
          this.rowCount = this.nbPage * 50;
          this.listUserEcoportail.forEach(elt => {
            elt.agence = elt.agence || this.listeAgence[0];
            elt.chantier = elt.chantier || this.listChantier[0];
          });
        }
      }
      this.listUserEcoportail = [...this.listUserEcoportail]
    });
  }

  searchHandle() {
    this.page = 0;
    this.orderBy = "";
    this.isAsc = false;
    this.getListUser();
  }

  searchChantier(event) {
    this.listChantier = [{id: 0, libelleObjetEntite: 'Tous'}];
    const param = {
      'servlet': 'DBGetChantierClient',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {

        'SITE': {
          'typeParam': 'int',
          'valeur': this.common.user[2]
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || 0
        },
        'CRITERE': event && event !== 'Tous' ? event : ''
      }
    };

    return this.common.post('', {param: param}).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listChantier = [...this.listChantier, ...datas.data];
      }
    });
  }

  getListeAgence(event?) {
    const param = {
      'servlet': 'DBAgenceGet',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || 0
        },
        'CRITERE': event || ''
      }
    };
    console.log('Agence');
    return this.common.post('', {param: param}).then(datas => {
      // $('#autocomplete').trigger('click');
      if (this.common.verifySession(datas)) {
        this.listeAgence = [...this.listeAgence, ...datas.data];
      }
    });
  }

  focus(event) {
    const input = event.target;
    const originalValue = $(input).val();
    $(input).val('');
    $(input).blur().focus().val(originalValue);
  }

  update() {
    const listUserEcoportail = [];
    if(this.detail['listeAssoClientWidgetEcoPortail'] && this.detail['listeAssoClientWidgetEcoPortail'].length) {
      this.detail['listeAssoClientWidgetEcoPortail'].forEach(elemnt => {
        elemnt.nomclass = 'AssoClientWidgetEcoPortail';
      });
    } 

    const listUserEcoportailToSave = this.listUserEcoportail.filter(elt => elt.isEdit)
    console.log('avant update user');
    console.log(listUserEcoportailToSave);
    listUserEcoportailToSave.forEach(elt => {
      const obj = Object.assign({}, elt);
      listUserEcoportail.push(obj);
      delete elt.isEdit;
      delete elt.index;
      elt.isDocSsChantierAgence = elt.isDocSsChantierAgence || false;
      elt.isDocumentsUser = elt.isDocumentsUser || false;
      elt.isLibraDataUser = elt.isLibraDataUser || false;
      elt.isPriseCommandeUser = elt.isPriseCommandeUser || false;
      elt.isDemande = elt.isDemande || false;
      elt.isDesactive = elt.isDesactive || false;
      // if (elt.pwdModel) {
      //   elt.pwd = elt.pwdModel;
      // }
      if (elt['nouvelleMDP']) {
        elt['pwd'] = elt['nouvelleMDP'];
      };
      elt.nomclass = 'UserEcoGED';
      if (this.isDepuisFicheDetenteur) {
        elt.chantier = {
          id: this.chantier.id,
          libelleObjetEntite: ''
        }
      }
    });
    const param = {
      'servlet': 'DBGestionUserEcoGED',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': this.isDepuisFicheDetenteur ? 4 : 2
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': this.detail['id'] || 0
        },
        'LIST_USER_ECOGED': listUserEcoportailToSave,
        'LISTE_ASSO_CLIENT_WIDGET_ECOPORTAIL' : this.detail['listeAssoClientWidgetEcoPortail'] || []
      }
    };

    if (this.isDepuisFicheDetenteur) {
      param['data']['CLEF_CHANTIER'] = {
        'typeParam': 'int',
        'valeur': this.chantier['id'] || 0
      };
    }

    return this.common.post('', {param: param}).then(dataUserEcoGED => {
      console.log('after update user');
      console.log(listUserEcoportail);
      let userEcoGEDWithOldPassword = [];
      if(dataUserEcoGED.data) {
          userEcoGEDWithOldPassword = dataUserEcoGED.data;
      }
      
      listUserEcoportail.forEach(user => {
        if (user.isEdit) {
          user['oldPassword'] = this.getOldPasswordUser(user.id, userEcoGEDWithOldPassword);
          this.updatePwdEcostat(user, this.chantier);
        }
      });
      this.hide();
    });
  }

    getOldPasswordUser(id: number, listUserEcoportail: any[]): string | null {
      const user = listUserEcoportail.find(user => user.id === id);
      return user ? user.oldPassword : null;
    }  

  updatePwdEcostat(user, chantier?) {
    const societe = this.common.local.getObject('paramSociete') || {};
    const url = this.common.intercept(`${societe.urlLibraData || ''}${environment.api_url_ecostat}`);
        const data = {
            id: user['id'],
            nom: this.detail['nomClient'] || '',
            prenom: this.detail['prenom'] || '',
            clefChantier: chantier ? chantier['id'] : (user['chantier'] ? user['chantier'].id || 0 : 0),
            numChantier: chantier ? chantier['numChantier'] : (user['chantier'] ? user['chantier'].numChantier || '' : ''),
            numChantier2: chantier ? chantier['numChantier2'] : (user['chantier'] ? user['chantier'].numChantier2|| '' : ''),
            prenomDetenteur: chantier ? chantier['prenomDetenteur'] : (user['chantier'] ? user['chantier'].prenomDetenteur || '' : ''),
            villeChantier: chantier ? chantier['ville'] : (user['chantier'] ? user['chantier'].ville || '' : ''),
            clefSiteChantier: chantier  && chantier['siteChantier']? chantier['siteChantier']['id'] : (user['site'] ? user['site'].id || 0 : 0),
            siteChantier: chantier && chantier['siteChantier']? chantier['siteChantier']['nom'] : (user['site'] ? user['site'].nom || '' : ''),
            pwd:  user['nouvelleMDP'] ? user['nouvelleMDP'] : (user['pwd'] || ''),
            login: user['login'],
            clefClient: this.detail['id'] || 0,
            codeClient: this.detail['codeClient'] || '',
            clefHoldingSocieteFille : societe.clefHoldingSocieteFille || 0,
            oldPassword : user['oldPassword']
        };

        if(societe.urlLibraData) {
      return this.common.postURL(url, {user: data});
        } else {
          return Promise.resolve();
        }
  }
  
  /*
  getOldPwd(clefUserEcoGED, login) {
    const param = {
      'servlet': 'DBGestionUserEcoGED',
      'module': 'Recylog',
      'type': 'map',
      'compression': 'false',
      'data': {
        'OPERATION': {
          'typeParam': 'int',
          'valeur': 5
        },
        'CLEF_USER_ECOGED': {
          'typeParam': 'int',
          'valeur': clefUserEcoGED
        },
        'LOGIN': {
          'typeParam': 'string',
          'valeur': login
        },
        'CLEF_CLIENT': {
          'typeParam': 'int',
          'valeur': 0
        }
      }
    };
    
    this.listUserEcoportail = [];
    return this.common.post('', { param: param }, true).then(datas => {
      $('#empty').trigger('click');
      if (this.common.verifySession(datas)) {
        if (datas.data) {
            return datas.data
        }
      }
    });
  }  
  */

  togglePasswordVisibility(row) {
    row.showPwd = !row.showPwd;
  }

  getPasswordType(row) {
    return row.showPwd ? 'text' : 'password';
  }

  sortBy(name) {
    this.orderBy = name;
    this.isAsc = !this.isAsc;
    this.getListUser()
  }

  onFooterPage(event) {
    this.page = event.page - 1;
    this.getListUser();
  }

}
